<div class="product-image-container" [ngClass]="{'blue-border': showBorder, 'circle-border': circle, 'radius':radius}">
    <img [src]="product.imgProduct" alt="envase"
        *ngIf="product.imgProduct !== '' && product.imgProduct !== undefined && product.imgProduct !== null"
        (click)="openImageViewer()" class="cursor-pointer" [ngClass]="imageOpacity ? 'image-opacity':''">
    <img src="assets/icons/no-image.svg" alt="sin envase" [ngClass]="imageOpacity ? 'image-opacity':''"
        *ngIf="product.imgProduct === '' || product.imgProduct === undefined || product.imgProduct === null">
</div>